export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11854.eda6dd3a.jpg";